import { IRateTypes } from '../../types'

export const RATE_TYPE_OPTIONS = [
  {
    label: 'Any Rate',
    value: IRateTypes.anyRate,
  },
  {
    label: 'Rate per mile',
    value: IRateTypes.ratePerMile,
  },
  {
    label: 'Total all-in',
    value: IRateTypes.totalAllIn,
  },
]

export const RATE_FIELD_PLACEHOLDERS: Record<IRateTypes, string> = {
  [IRateTypes.anyRate]: '',
  [IRateTypes.ratePerMile]: 'Enter rate per mile',
  [IRateTypes.totalAllIn]: 'Enter total all-in rate',
}

export type TRateFieldPlaceholders = typeof RATE_FIELD_PLACEHOLDERS
